<template>
    <div class="contract-files-modal">
        <DataTable
            :value="modalStore.data.files"
            responsiveLayout="scroll"
            sortField="created_at"
            :sortOrder="1"
        >
            <Column
                field="name"
                :header="$t('§invoices.tab_table_header_file')"
            >
                <template #body="slotProps">
                    <CoreTableCellButton
                        :disabled="contractFilesStore.downloading"
                        icon="pi-download"
                        :loading="contractFilesStore.downloading"
                        :label="slotProps.data.name"
                        @click="getFile(slotProps.data)"
                    />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import Tag from 'primevue/tag'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import { useModalStore } from '@/stores/modal'
import { useContractFilesStore } from '@/stores/contractFiles'
import CoreTableCellButton from '@/components/core/CoreTableCellButton.vue'
import CoreValueMissing from '@/components/core/CoreValueMissing.vue'

export default {
    name: 'ContractFilesModal',

    components: {
        CoreTableCellButton,
        CoreValueMissing,
        Tag,
        Column,
        DataTable,
    },

    created() {
        this.modalStore = useModalStore()
        this.contractFilesStore = useContractFilesStore()
    },

    methods: {
        getFile(file) {
            if (!this.contractFilesStore.downloading) {
                this.contractFilesStore.downloadInvoice({
                    invoiceId: this.modalStore.data.invoiceId,
                    fileId: file.id,
                    fileName: file.name,
                })
            }
        },
    },
}
</script>

<style>
.contract-files-modal {
    padding: 40px;
}
.contract-files-modal-item-row {
    padding: 0.6rem 0.8rem;

    &.total-row span {
        font-weight: bold;
    }

    &:nth-child(even) {
        background-color: var(--color-neutral-500);
        border-radius: 4px;
    }
}

.contract-files-modal-total-row {
    padding: 0.6rem 0.8rem;
    margin-top: 1rem;

    span {
        font-weight: bold;
        font-size: 2.3rem;
    }
}
</style>
